import { ActionAfterViewed } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { CardSectionNew } from 'shared/components/CardSectionNew';
import { selectIsMortgageBrokerBannerAvailable } from 'shared/selectors/mortgageBroker';

import { MortgageBrokerBanner } from './components/MortgageBrokerBanner';
import { trackMortgageBrokerBannerClick, trackMortgageBrokerBannerShow } from './tracking';
import { useApplicationContext } from '../ApplicationContext';

const URL_QUERY = '?cian_source=object_card';

/**
 * Основной баннер сервиса "Ипотечный брокер" (Циан.Ипотека для профи).
 */
export function MortgageBrokerBannerContainer() {
  const { config } = useApplicationContext();
  const isBannerEnabled = useSelector(selectIsMortgageBrokerBannerAvailable);

  if (!isBannerEnabled) {
    return null;
  }

  const calculatorUrl = config.get<string>('mortgage-broker-calculator-frontend.baseUrl') + URL_QUERY;
  const promoUrl = config.get<string>('mortgage-broker-application-frontend.promoUrl') + URL_QUERY;

  return (
    <CardSectionNew hideForPrint>
      <ActionAfterViewed callback={trackMortgageBrokerBannerShow}>
        <MortgageBrokerBanner
          calculatorUrl={calculatorUrl}
          promoUrl={promoUrl}
          onLinkClick={trackMortgageBrokerBannerClick}
        />
      </ActionAfterViewed>
    </CardSectionNew>
  );
}
